import { defineStore } from "pinia";
import { StateTree, _GettersTree, _ActionsTree } from "pinia";

// Interfaz del estado
interface SavingState extends StateTree {
  selectedSaving: Record<string, any> | null; // Contribución seleccionada
}

// Interfaz de getters
interface SavingGetters extends _GettersTree<SavingState> {
  getSelectedSaving: (state: SavingState) => Record<string, any> | null;
}

// Interfaz de acciones
interface SavingActions extends _ActionsTree {
  setSelectedSaving(saving: Record<string, any>): void;
  clearSelectedSaving(): void;
}

// Definición del store
export const useSavingStore = defineStore<
  "saving",
  SavingState,
  SavingGetters,
  SavingActions
>("saving", {
  // Estado inicial
  state: () => ({
    selectedSaving: null,
  }),

  // Getters
  getters: {
    // Obtener la contribución seleccionada
    getSelectedSaving: (state) => state.selectedSaving,
  },

  // Acciones
  actions: {
    // Establecer la contribución seleccionada
    setSelectedSaving(saving) {
      this.selectedSaving = saving;
    },

    // Limpiar la contribución seleccionada
    clearSelectedSaving() {
      this.selectedSaving = null;
    },
  },

  // Persistencia opcional para mantener la contribución seleccionada en el almacenamiento local
  persist: {
    storage: localStorage,
    pick: ["selectedSaving"],
  },
});
